import Offcanvas from '../../../../../components/new_offcanvas/offcanvas_menu'
import FormFilter from "../../../../../components/map/filter_marker_form/filter_marker_form"
import filter_view from './filter_view'
export default function OffcanvasFilter(options){
    let mapComponent = options.mapComponent
    let formFilter, _filter_view

    let offcanvas = new Offcanvas({
        id: options.id,
        title: "Filtrar Postos",
        subtitle: "Filtre apenas os postos de seu interesse",
        height: "offcanvas-hlg",
        position:'right'
    })

    let station = options.station

    this.generate = () =>{
        offcanvas.generate()
        offcanvas.appendToBody("<div id='filter_markers_form'></div>")
        this.generateForm()
        // this.show()
    }

    this.generateForm = () =>{
        let fields = ['ugrhi','city','station_owner', 'transmission_status']
        
        //inicializando component
        formFilter = new FormFilter({
            container: '#filter_markers_form', //container do html do filtro
            markers: mapComponent.getLayer('markers').getLayers(), //lista de marcadores 
            filter_options_list: fields, //campos que poderam ser filtrados
            on_change_filter: true, //disparara evento 'filtered' no 'on change' dos form-controls,
            submit_button: {show:true, text:'Filtrar', class:'btn btn-outline-primary w-75'}, //opçoes do botão submit
            clear_button: {show:true, text:'<i class="fa fa-times">', class:'btn btn-outline-danger w-25'},
            show_total_results: true,
            title: {text:'', class:""},
            default_filter_option: true
        })
        //gerando formulário de filtro
        formFilter.generate()
    }

    this.filterMakers = (params) =>{
        $.each(params, (field, values) =>{
            formFilter.setSelectValue(field, values)
        })
        formFilter.filter()
    }

    this.show = () =>{
        offcanvas.show()
    }

    this.hide = () =>{
        offcanvas.hide()
    }
    this.getCurrentFilter = _ =>{
        return formFilter.getCurrentFilter()
    }

    this.saveFilter = _ =>{
        formFilter.saveFilter()
    }

    
}